<script setup lang="ts">
import { computed, onUnmounted, ref } from 'vue';

import LoadingThrobber from './LoadingThrobber.vue';

const comments = [
  'Initialising the discombobulator',
  'Grabbing data from cyberspace',
  'Loading up the bourgeoisie',
  'Rendering the mise en scène',
  'Presenting a smörgåsbord of scores',
  'The hamster is now running at full speed',
  'Please be patient',
];

const currentComment = ref(0);
const comment = computed(() => comments[currentComment.value]);
const interval = ref();

interval.value = setInterval(() => {
  if (currentComment.value + 1 >= comments.length) {
    return clearInterval(interval.value);
  }
  return currentComment.value++;
}, 1000);

onUnmounted(() => {
  clearInterval(interval.value);
});
</script>

<template>
  <div class="loading">
    <LoadingThrobber class="loading__throbber" />
    {{ comment }}
  </div>
</template>

<style lang="scss" scoped>
.loading {
  align-items: center;
  color: #676565;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding-top: 1.25rem;

  &__throbber {
    margin-bottom: 0.5rem;
  }
}
</style>
